var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectMessanger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.49334 2 2 5.30112 2 9.76C2 12.0923 2.95584 14.1077 4.51244 15.4997C4.64312 15.6167 4.722 15.7805 4.72734 15.9558L4.77091 17.3789C4.78481 17.8328 5.25369 18.1282 5.66906 17.9448L7.25694 17.2438C7.3915 17.1845 7.54243 17.1734 7.68422 17.2124C8.41391 17.4131 9.1905 17.52 9.99997 17.52C14.5066 17.52 18 14.2188 18 9.75997C18 5.30109 14.5066 2 10 2Z",
    fill: "url(#paint0_radial_14735_94762)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19604 12.0294L7.54604 8.3011C7.91986 7.70797 8.72032 7.56028 9.2812 7.98094L11.1503 9.38275C11.2337 9.44536 11.3353 9.47907 11.4396 9.47877C11.544 9.47847 11.6454 9.44418 11.7285 9.3811L14.2528 7.46535C14.5897 7.20966 15.0295 7.61288 14.804 7.97069L12.454 11.699C12.0802 12.2921 11.2797 12.4398 10.7189 12.0192L8.84973 10.6173C8.76626 10.5547 8.66468 10.521 8.56035 10.5213C8.45603 10.5216 8.35464 10.5559 8.27154 10.619L5.74726 12.5348C5.41032 12.7904 4.97051 12.3872 5.19604 12.0294Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14735_94762",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.08125 17.8057) scale(17.425 17.425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectMessanger);
export default __webpack_public_path__ + "4a6107574d07f891ea40b725f2a6cf15.svg";
export { ForwardRef as ReactComponent };